import { RailsLander } from '@sls-react/typings/services/rails/landers';
import fetcher, { makeFetcher } from '@sls-react/api/fetcher';
import { RailsPredictiveSearchResult } from '@sls-react/typings/services/rails/predictiveSearch';

export const fetchLanderById = makeFetcher<RailsLander>(
  (id: number) => `/v1/landers/${id}`,
);

export const fetchSuggestedLanderById = makeFetcher<RailsLander>(
  (id: number) => `/v1/landers/${id}/suggested_lander`,
);

export const fetchLandersBySlug = makeFetcher<RailsLander[]>((slug: string) => [
  '/v1/landers',
  {
    params: {
      slug,
    },
  },
]);

type PredictiveFilter = 'canonical_model' | 'relatable_category' | 'listable';

export const fetchPredictiveSearch = (
  query: string,
  filters?: PredictiveFilter[],
) =>
  fetcher<RailsPredictiveSearchResult[]>('/v1/predictive_search', {
    params: {
      q: query,
      filter_type: filters,
    },
  });
